<template>
    <div class="panel__actions">
        <router-link class="btn" to="/dodaj-wpis">Dodaj wpis</router-link>
        <router-link class="btn" to="/nieruchomosci">Zobacz wpisy</router-link>
    </div>
</template>

<script>

export default {
  name: 'home'
}
</script>
